import { Checkbox, FormControlLabel } from '@mui/material'
import { useDispatch } from 'react-redux'

const CheckboxField = ({
  name = '',
  label = '',
  checked = false,
  standalone = false,
  setter = null,
  // formikSetter = null,
  handler = null,
  className = 'input_field checkbox_field',
  onBlur,
  onChange,
  ...props
}) => {
  const dispatch = useDispatch()
  // console.log(props)

  const handleChange = (e) => {
    const checked = e.target.checked
    if (standalone) {
      if (setter) {
        dispatch(setter(checked))
      }
    } else {
      // formikSetter(name, checked)
      onChange(e)
      if (handler) {
        handler({ name, checked })
      }
    }
  }

  return (
    <FormControlLabel
      name={name}
      onBlur={onBlur}
      control={<Checkbox checked={checked} onChange={handleChange} className="checkbox" />}
      label={label}
      className={className}
      slotProps={{
        typography: {
          className: 'checkbox_label',
        },
      }}
    />
  )
}

export default CheckboxField
